import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import * as dep from "modules/login/ah-caw-footer-module/6.2.1/js/dep";
import spartaTemplates from "modules/login/ah-caw-footer-module/6.2.1/js/templates";
import "css!modules/login/ah-caw-footer-module/6.2.1/css/ah-caw-footer-module.scss.css";









export default class ahCawFooterModuleJS extends Module {
  constructor(options) {
    super(options);
    this.moduleData =  options.moduleData;
  }

  init(args = {}) {

    $('.secure-signin-cancel').focusout( ()=> {
      $('#forgot-id-pass').focus();
    });

    $(this.settings.$target).find('#expand-collapse-handle').off('click.expand-collapse').on('click.expand-collapse', function () {
      const $this = $(this);
      const $parent = $this.parent('.help-options-wrapper');

      $parent.toggleClass('collapsed');
      if ($parent.is('.collapsed')){
        $parent.find(`> .help-options`).addClass('hidden');
      }else{
        $parent.find(`> .help-options`).removeClass('hidden');
      }

      $this.find('.triangle-icon--expand,.triangle-icon--collapse').toggleClass('hidden');
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_WIDGET_FOOTER, (e) => {
      $(this.settings.$target).find('#ah-caw-footer-container').removeClass('hidden');
      $(this.settings.$target)
        .find(`#ah-caw-footer-container >.title > .help-options-wrapper >.help-option`).removeClass('hidden');
        if(e.data.originatingFrom === 'OCA-LS'){
          this._redrawFooter(e.data.originatingFrom,e.data.clientId,e.data.context);
          $(this.settings.$target).find('#caw-forgot').remove();
          $(this.settings.$target).find('#gwim-forgot').removeClass('hidden');
          if(_.get(e,'data.footerEnroll') === "true"){
            $(this.settings.$target).find('#enroll-container').removeClass('hidden');
          }
        } 
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS, () => {
      $(this.settings.$target)
        .find(`#ah-caw-footer-container .help-options-wrapper > .title,
        #ah-caw-footer-container .help-options-wrapper > .help-options`).addClass('hidden');
      $(this.settings.$target)
        .find(`#ah-caw-footer-container >.title > .help-options-wrapper >.help-option`).addClass('hidden');
        $(this.settings.$target)
        .find(`#ah-caw-footer-container >.title > div > .help-options-wrapper >.help-option`).addClass('hidden');
      $(this.settings.$target)
        .find(`#ah-caw-footer-container >.title > .help-options-wrapper >span`).addClass('hidden');


      $(this.settings.$target)
        .find('#ah-caw-footer-container .help-options-wrapper').addClass('no-options');
      $(this.settings.$target)
        .find('#gwim-forgot').addClass('hidden');
        $(this.settings.$target)  
        .find('#third-party-forgot > .help-option').addClass('hidden');
        $(this.settings.$target)  
        .find('#third-party-forgot').addClass('hidden');
    });



         this.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_WIDGET_FOOTER_HELP_OPTIONS, () => {





      $(this.settings.$target)
        .find(`#ah-caw-footer-container .help-options-wrapper > .title`).removeClass('hidden')

      $(this.settings.$target)
        .find('#ah-caw-footer-container .help-options-wrapper').removeClass('no-options');
    });

    const basePath = ahCawCommons.getBasePath(this.spaParams);

    $(this.settings.$target).find('.help-option').each(function () {
      $(this).attr('href', basePath + $(this).attr('data-href'));
    });
  }

  _redrawFooter(brand,client,context){
    if(brand === "OCA-LS"){
      let domain = this.spaParams.siteParams[client.toLowerCase()+'Endpoint'];
      if(client === 'PB' && context === 'RPS'){
         domain = this.spaParams.siteParams.rpsSitePBEndpoint;
      }
      $(this.settings.$target).find('#forgot-oid').html(this.moduleData.text[client+`-forgot-oid`]);
      $(this.settings.$target).find('#forgot-pwd').html(this.moduleData.text[client+`-forgot-pwd`]);
      if(client === 'BOL' && context === 'LINKAGE'){
        $(this.settings.$target).find('#forgot-oid').attr('href',domain+this.moduleData.href['forgot-bol-oid']);
        $(this.settings.$target).find('#forgot-pwd').attr('href',domain+this.moduleData.href['forgot-bol-pass']);
      }
      else{
        $(this.settings.$target).find('#forgot-oid').attr('href',domain+this.moduleData.href[client+`-forgot-oid`]);
        $(this.settings.$target).find('#forgot-pwd').attr('href',domain+this.moduleData.href[client+`-forgot-pwd`]);
      }
      $(this.settings.$target).find('#enroll').attr('href',domain+this.moduleData.href[client+`-enroll`]);
      $(this.settings.$target).find('#enroll').html(this.moduleData.text[client+`-enroll`]);
    }else if(brand === 'BOL'){
      let bolEp = this.spaParams.siteParams.bolEndpoint;
        $(this.settings.$target).find('#forgot-oid').attr('href',bolEp+this.moduleData.href['bol-forgot-oid']);
        $(this.settings.$target).find('#forgot-pwd').attr('href',bolEp+this.moduleData.href['bol-forgot-pass']);
    }
  }
}
